import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateTeamMeetingConfigQuery } from './useTeamMeetingConfigQuery';
import { invalidateTeamMeetingConfigsQuery } from './useTeamMeetingConfigsQuery';

export interface ITeamMeetingConfigDeleteMutationOptions {
	onSuccess?: (data: Api.ITeamMeetingConfig) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
}

/**
 * Soft delete mutation - sets enabled=false on the config
 */
export function useTeamMeetingConfigDeleteMutation(options: ITeamMeetingConfigDeleteMutationOptions = {}) {
	const { onSuccess, onError } = options;
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (id: string) => {
			return userSession.webServiceHelper.callAsync<Api.ITeamMeetingConfig>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `TeamMeetingConfig/${id}`,
				}),
				'DELETE'
			);
		},
		onSuccess: data => {
			invalidateTeamMeetingConfigsQuery();
			invalidateTeamMeetingConfigQuery(data.id);
			onSuccess?.(data);
		},
		onError,
	});
}
